export enum HttpResponseTypeEnum {
  Success = 200,
  BadRequest = 400,
  Unauthorized = 401,
  AccessDenied = 403,
  userCreated = 201,
  Accepted = 202,
}
